import { useEffect } from "react";
import { batch, useSignal } from "@preact/signals-react";
import { postSubmit, isEmpty } from "@ui-seeker/utils";
import { useAppToast } from "@ui-seeker/app";

import { WEBBACK_V2_API } from "@constants";
import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import { elementsInLoading, resetMarketplacesLostBuyBoxOverviewSignal } from "../signals";


export default function useLostBuyBoxOverviewShareReasonChartsData() {

	const { showToast } = useAppToast()

	const isLoadingCharts = useSignal(false)
	const chartsData = useSignal(false)

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			isLoadingCharts.value = true
			resetMarketplacesLostBuyBoxOverviewSignal()
			postSubmit(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-overview/reason-share`, commonFiltersValue.value).then((res) => {
				chartsData.value = res
                isLoadingCharts.value = false
			}).catch(() => {
				isSystemBusy.value = true
                isLoadingCharts.value = false
				isLoadingCommonFilters.value = false
            })
		})
	}, [isLoadingCommonFilters.value]);


	useEffect(() => {
		if (isLoadingCharts.value)
			elementsInLoading.value = [...elementsInLoading.value, 'reasonCharts']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'reasonCharts')
	}, [isLoadingCharts.value])

	return {
		reasonChartsData: chartsData.value,
        isLoadingReasonCharts: isLoadingCharts.value
	}
}